document.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");

  let currentSize = "";
  const productSizes = new Map(); // Pour stocker les tailles par produit

  function syncAllSizes(changedInput) {
    console.log("Syncing size:", changedInput.value);
    const currentProductForm = changedInput.closest('form[action="/cart/add"]');
    const productId = currentProductForm?.querySelector('[name="id"]')?.value;

    if (!productId) {
      console.log("No product ID found");
      return;
    }

    currentSize = changedInput.value;
    productSizes.set(productId, currentSize);

    // Ne synchroniser que les inputs du même produit
    const sameProductInputs = currentProductForm.querySelectorAll(
      `input[type="radio"][name^="Taille-"], input[type="radio"][name^="Size-"], 
       select[name^="options[Taille]"], select[name^="options[Size]"]`
    );

    sameProductInputs.forEach((input) => {
      if (input !== changedInput) {
        if (input.type === "radio") {
          input.checked = input.value === changedInput.value;
        } else if (input.tagName === "SELECT") {
          input.value = changedInput.value;
        }
        console.log("Updated input:", input.name, "to", changedInput.value);
        updateSizeLabel(input);
      }
    });

    updateCartWithNewSize(productId, currentSize);
    updateHiddenSizeField(currentProductForm, currentSize);
  }

  function updateSizeLabel(input) {
    const form = input.closest("form") || input.closest("variant-selects");
    if (form) {
      const label = form.querySelector(
        ".form__label .value strong, [data-selected-value]"
      );
      if (label) {
        label.textContent = input.value;
        console.log("Updated size label to:", input.value);
      }
    }
  }

  function updateCartWithNewSize(productId, size) {
    console.log("Updating cart with new size for product:", productId);

    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const updates = cart.items.map((item) => {
          // Ne mettre à jour que si c'est le même produit variant
          if (item.variant_id.toString() === productId.toString()) {
            return {
              id: item.key,
              properties: {
                ...item.properties,
                _Taille: size,
                Taille: size,
              },
            };
          }
          // Garder les autres articles inchangés
          return {
            id: item.key,
            properties: item.properties,
          };
        });

        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });
      })
      .then((response) => response.json())
      .then((updatedCart) => {
        console.log("Cart updated:", updatedCart);
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
      });
  }

  function updateHiddenSizeField(form, size) {
    if (!form) return;

    let hiddenSizeField = form.querySelector(
      'input[name="properties[_Taille]"]'
    );
    if (!hiddenSizeField) {
      hiddenSizeField = document.createElement("input");
      hiddenSizeField.type = "hidden";
      hiddenSizeField.name = "properties[_Taille]";
      form.appendChild(hiddenSizeField);
    }
    hiddenSizeField.value = size;
    console.log("Updated hidden size field to:", size);
  }

  function handleSizeChange(event) {
    if (
      event.target.matches(
        'input[type="radio"][name^="Taille-"], input[type="radio"][name^="Size-"]'
      ) ||
      (event.target.tagName === "SELECT" &&
        (event.target.name.startsWith("options[Taille]") ||
          event.target.name.startsWith("options[Size]")))
    ) {
      console.log("Size changed to:", event.target.value);
      syncAllSizes(event.target);
    }
  }

  // Écouter les changements sur tout le document
  document.addEventListener("change", handleSizeChange, true);

  // Observer les changements dans le DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const newSizeInputs = node.querySelectorAll(
              'input[type="radio"][name^="Taille-"], input[type="radio"][name^="Size-"], select[name^="options[Taille]"], select[name^="options[Size]"]'
            );
            if (newSizeInputs.length > 0) {
              newSizeInputs.forEach((input) => {
                input.addEventListener("change", handleSizeChange);
              });
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  console.log("Size sync and cart update script initialized");
});
